// ================================================================
//  Volerto 2.0 Hearing Aid LP — JavaScript
//  Each bundle maps to its own Shopify variant with correct price.
// ================================================================

var VA_VARIANTS = {
  '1': 48291776954627,   // 1 pair  — $179.00
  '2': 48291776987395,   // 2 pairs — $299.00
  '3': 48291777020163    // 3 pairs — $399.00
};
var VA_QTY_MAP = { '1': 1, '2': 1, '3': 1 };

// ─── STATE ────────────────────────────────────────────────
const state = {
  cart: [],
  selectedQty: '1',
  selectedPrice: 179.00,
  selectedCompare: 239.00,
  atcQty: '1'
};

const atcPricing = {
  '1': { price: 179.00, compare: 279.00, savings: 100.00, discount: 36, label: '1 Pair' },
  '2': { price: 299.00, compare: 558.00, savings: 259.00, discount: 46, label: '2 Pairs' },
  '3': { price: 399.00, compare: 837.00, savings: 438.00, discount: 52, label: '3 Pairs' }
};

// Format cents in the buyer's presentment currency (falls back to $).
function fmtMoney(cents, currency) {
  currency = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
  } catch (e) {
    return '$' + (cents / 100).toFixed(2);
  }
}

// ─── COUNTDOWN ────────────────────────────────────────────
const SALE_DAYS = 2;
const saleEnd = new Date(Date.now() + SALE_DAYS * 24 * 60 * 60 * 1000);

function updateCountdown() {
  const now = new Date();
  let diff = Math.max(0, saleEnd - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const pad = n => String(n).padStart(2, '0');
  const setEl = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = pad(val); };
  setEl('cd-d', d); setEl('cd-h', h); setEl('cd-m', m); setEl('cd-s', s);
}
updateCountdown();
setInterval(updateCountdown, 1000);

// ─── STOCK BAR TIMER ──────────────────────────────────────
let stockSeconds = 1 * 3600 + 18 * 60 + 44;
function updateStockTimer() {
  stockSeconds = Math.max(0, stockSeconds - 1);
  const h = Math.floor(stockSeconds / 3600);
  const m = Math.floor((stockSeconds % 3600) / 60);
  const s = stockSeconds % 60;
  const pad = n => String(n).padStart(2, '0');
  const el = document.getElementById('stockTimer');
  if (el) el.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
  const bel = document.getElementById('bonusTimer');
  if (bel) bel.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
}
setInterval(updateStockTimer, 1000);

function jitterStockNumbers() {
  const viewing = document.getElementById('viewingNow');
  const sold = document.getElementById('soldToday');
  if (viewing) {
    let v = parseInt(viewing.textContent.replace(/,/g, ''));
    v = Math.max(30, v + Math.floor(Math.random() * 5) - 2);
    viewing.textContent = v;
  }
  if (sold) {
    let s = parseInt(sold.textContent.replace(/,/g, ''));
    s += Math.floor(Math.random() * 2);
    sold.textContent = s.toLocaleString();
  }
}
setInterval(jitterStockNumbers, 8000);

// ─── QUANTITY SELECTOR ────────────────────────────────────
function selectQty(btn) {
  document.querySelectorAll('.quantity-option').forEach(el => el.classList.remove('active'));
  btn.classList.add('active');
  state.selectedQty = btn.dataset.qty;
  state.selectedPrice = parseFloat(btn.dataset.price);
  state.selectedCompare = parseFloat(btn.dataset.compare);
  state.atcQty = state.selectedQty;
  updateStickyAtcDisplay();
  syncAtcPills(state.selectedQty);
  var variantIds = { '1': 48291776954627, '2': 48291776987395, '3': 48291777020163 };
  var heroTerms = document.getElementById('heroPaymentTerms');
  if (heroTerms && variantIds[state.selectedQty]) heroTerms.setAttribute('variant-id', variantIds[state.selectedQty]);
  const labels = {
    '1': '1 Pair of Volerto 2.0 Hearing Aids',
    '2': '2 Pairs of Volerto 2.0 Hearing Aids',
    '3': '3 Pairs of Volerto 2.0 Hearing Aids'
  };
  const boxQtyEl = document.getElementById('boxQty');
  if (boxQtyEl) boxQtyEl.textContent = labels[state.selectedQty] || labels['1'];
}

// ─── CERT DROPDOWN ────────────────────────────────────────
function toggleCertDropdown() {
  document.getElementById('certDropdown').classList.toggle('open');
}

// ─── SHOPIFY CART (single source of truth) ────────────────
var _shopifyCart = { items: [], item_count: 0, total_price: 0 };

function _fetchCart() {
  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      _shopifyCart = cart;
      _renderCart();
      return cart;
    })
    .catch(function() {});
}

function _cartAdd(variantId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  }).then(function(r) {
    if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Could not add to cart'); });
    return _fetchCart();
  });
}

function _cartChange(key, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r) { return r.json(); })
    .then(function(cart) { _shopifyCart = cart; _renderCart(); })
    .catch(function() {});
}

function _renderCart() {
  var cart = _shopifyCart;
  var countEl = document.getElementById('cartCount');
  if (countEl) countEl.textContent = cart.item_count || 0;

  var itemsEl  = document.getElementById('cartItems');
  var footerEl = document.getElementById('cartFooter');
  var emptyEl  = document.getElementById('cartEmpty');
  if (!itemsEl) return;

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '';
    if (emptyEl) itemsEl.appendChild(emptyEl);
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  var cartCur = cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var prodImg = (window.VA_BUNDLE_IMAGES || {}).single || '';
  itemsEl.innerHTML = cart.items.map(function(item) {
    var linePrice = fmtMoney(item.line_price, cartCur);
    var imgHtml = prodImg
      ? '<img src="' + prodImg + '" alt="Volerto 2.0" loading="lazy" style="width:100%;height:100%;object-fit:contain;">'
      : '';
    return '<div class="cart-item" data-key="' + item.key + '">'
      + '<div class="cart-item__image" style="padding:0;background:none;border:none;">' + imgHtml + '</div>'
      + '<div><div class="cart-item__name">' + item.product_title + '</div>'
      + '<div class="cart-item__variant">' + item.variant_title + '</div>'
      + '<div class="cart-item__qty">'
      + '<button onclick="_cartChange(\'' + item.key + '\',' + Math.max(0, item.quantity - 1) + ')">−</button>'
      + '<span>' + item.quantity + '</span>'
      + '<button onclick="_cartChange(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>'
      + '</div></div>'
      + '<div style="text-align:right;">'
      + '<div class="cart-item__price">' + linePrice + '</div>'
      + '<div class="cart-item__remove" onclick="_cartChange(\'' + item.key + '\',0)">Remove</div>'
      + '</div></div>';
  }).join('');

  var subEl = document.getElementById('cartSubtotal');
  if (subEl) subEl.textContent = fmtMoney(cart.total_price, cartCur);
  if (footerEl) footerEl.style.display = 'block';
}

// ─── ADD TO CART ──────────────────────────────────────────
function addToCart() {
  var variantId = VA_VARIANTS[state.selectedQty];
  if (!variantId) return;
  var btn = document.getElementById('addToCartBtn');
  var original = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

  _cartAdd(variantId)
    .then(function() {
      if (btn) {
        btn.disabled = false;
        btn.classList.add('btn--success');
        btn.innerHTML = '✓ Added!';
        setTimeout(function() { btn.classList.remove('btn--success'); btn.innerHTML = original; }, 1400);
      }
      openCart();
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    });
}

function quickAdd(variant) {
  var qtyMap = { 'single': '1', 'couples': '2', 'family': '3' };
  var variantId = VA_VARIANTS[qtyMap[variant] || '1'];
  if (!variantId) return;
  _cartAdd(variantId).then(function() { openCart(); }).catch(function() {});
}

function stickyAddToCart() {
  var variantId = VA_VARIANTS[state.atcQty];
  if (!variantId) return;
  _cartAdd(variantId).then(function() { openCart(); }).catch(function() {});
}

// kept for backward compat (Wistia / other inline uses)
function updateCart() { _renderCart(); }

// ─── CART OPEN/CLOSE ──────────────────────────────────────
function openCart() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  hideToast();
}
function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
function goToCheckout() {
  var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  window.location.href = base + 'checkout';
}

// ─── ACCORDIONS ───────────────────────────────────────────
function toggleAccordion(btn) { btn.closest('.accordion-item').classList.toggle('open'); }
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
  if (!wasOpen) item.classList.add('open');
}

// ─── SAVINGS TABS ─────────────────────────────────────────
const savingsData = {
  '1': { total: '$3,821+', sub: 'You pay $179 instead of $4,000+ at a clinic', perPair: '$179.00' },
  '2': { total: '$7,701+', sub: 'You pay $299 instead of $8,000+ at a clinic', perPair: '$149.50' },
  '3': { total: '$11,601+', sub: 'You pay $399 instead of $12,000+ at a clinic', perPair: '$133.00' }
};

function switchSavingsTab(btn) {
  document.querySelectorAll('.savings-tab').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');
  const q = btn.dataset.qty;
  const P = window.V20_PRICING;
  if (P && P[q]) {
    document.getElementById('savingsAmount').textContent = `${P.clinicSave[q]}+`;
    document.getElementById('savingsSub').textContent = `You pay ${P[q].priceFmt} instead of ${P.clinic[q]}+ at a clinic`;
    document.getElementById('savingsPerPillow').innerHTML = `${P[q].perPairFmt}<small>/pair</small>`;
    return;
  }
  const data = savingsData[q];
  document.getElementById('savingsAmount').textContent = data.total;
  document.getElementById('savingsSub').textContent = data.sub;
  document.getElementById('savingsPerPillow').innerHTML = `${data.perPair}<small>/pair</small>`;
}

// ─── HERO CAROUSEL ────────────────────────────────────────
const carousel = {
  track:   document.getElementById('carouselTrack'),
  slides:  document.querySelectorAll('.carousel__slide'),
  thumbs:  document.querySelectorAll('.carousel__thumb'),
  current: 0,
  total:   8
};

function goToSlide(idx) {
  if (idx < 0) idx = carousel.total - 1;
  if (idx >= carousel.total) idx = 0;
  carousel.current = idx;
  carousel.track.style.transform = `translateX(-${idx * 100}%)`;
  carousel.slides.forEach((s, i) => s.classList.toggle('active', i === idx));
  carousel.thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
  scrollThumbIntoView(idx);

  if (carousel.badge) {
    if (idx === 0) {
      carousel.badge.classList.remove('visible');
      setTimeout(function() { carousel.badge.classList.add('visible'); }, 300);
    } else {
      carousel.badge.classList.remove('visible');
    }
  }
}

function scrollThumbIntoView(idx) {
  const strip = document.getElementById('carouselThumbs');
  if (!strip) return;
  const thumb = strip.children[idx];
  if (!thumb) return;
  const sRect = strip.getBoundingClientRect();
  const tRect = thumb.getBoundingClientRect();
  const delta = (tRect.left - sRect.left) - (strip.clientWidth - thumb.clientWidth) / 2;
  let target = Math.max(0, Math.min(strip.scrollLeft + delta, strip.scrollWidth - strip.clientWidth));
  strip.scrollTo({ left: target, behavior: 'smooth' });
}

function nextSlide() { goToSlide(carousel.current + 1); }
function prevSlide() { goToSlide(carousel.current - 1); }

const heroCarouselEl = document.getElementById('heroCarousel');
let touchStartX = 0, touchEndX = 0;
heroCarouselEl.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
heroCarouselEl.addEventListener('touchend', e => {
  touchEndX = e.changedTouches[0].screenX;
  const diff = touchStartX - touchEndX;
  if (Math.abs(diff) > 50) { diff > 0 ? nextSlide() : prevSlide(); }
}, { passive: true });
heroCarouselEl.setAttribute('tabindex', '0');
heroCarouselEl.addEventListener('keydown', e => {
  if (e.key === 'ArrowLeft') prevSlide();
  if (e.key === 'ArrowRight') nextSlide();
});

// ─── SALE BADGE ───────────────────────────────────────────
(function() {
  var badge = document.getElementById('saleBadge');
  if (!badge) return;
  carousel.badge = badge;
  badge.classList.add('visible');
})();

// ─── STICKY ATC ───────────────────────────────────────────
function syncAtcPills(qty) {
  document.querySelectorAll('#atcQtyPills .variant-pill').forEach(p => {
    p.classList.toggle('active', p.dataset.qty === qty);
  });
}

function atcSelectQty(btn) {
  document.querySelectorAll('#atcQtyPills .variant-pill').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  state.atcQty = btn.dataset.qty;
  state.selectedQty = state.atcQty;
  const pricing = atcPricing[state.atcQty];
  state.selectedPrice = pricing.price;
  state.selectedCompare = pricing.compare;
  document.querySelectorAll('.quantity-option').forEach(el => {
    el.classList.toggle('active', el.dataset.qty === state.atcQty);
  });
  updateStickyAtcDisplay();
}

function updateStickyAtcDisplay() {
  const q = state.atcQty;
  const p = atcPricing[q];
  const P = window.V20_PRICING;
  document.getElementById('atcPrice').textContent    = (P && P[q]) ? P[q].priceFmt   : `$${p.price.toFixed(2)}`;
  document.getElementById('atcCompare').textContent  = (P && P[q]) ? P[q].compareFmt : `$${p.compare.toFixed(2)}`;
  document.getElementById('atcDiscount').textContent = `-${p.discount}%`;
  document.getElementById('atcVariant').textContent  = p.label;
  document.getElementById('atcSavings').textContent  = (P && P[q]) ? P[q].saveFmt    : `$${p.savings.toFixed(2)}`;
}

const stickyAtcEl = document.getElementById('stickyAtc');
const visibilityFlags = { hero: true, shop: false };

function evaluateStickyAtc() {
  const shouldShow = !visibilityFlags.hero && !visibilityFlags.shop;
  if (shouldShow) {
    stickyAtcEl.classList.add('visible');
    if (window.innerWidth <= 768) hideToast();
  } else {
    stickyAtcEl.classList.remove('visible');
  }
}

const heroObs = new IntersectionObserver(([e]) => {
  visibilityFlags.hero = e.isIntersecting; evaluateStickyAtc();
}, { threshold: 0 });
heroObs.observe(document.getElementById('addToCartBtn'));

const shopObs = new IntersectionObserver(([e]) => {
  visibilityFlags.shop = e.isIntersecting; evaluateStickyAtc();
}, { threshold: 0.1 });
shopObs.observe(document.getElementById('shop'));

// ─── PURCHASE TOAST ───────────────────────────────────────
const fakePurchases = [
  { name: 'Patricia M.', flag: '🇬🇧', location: 'London',   product: '1 Pair' },
  { name: 'Robert H.',   flag: '🇬🇧', location: 'Manchester',   product: '2 Pairs' },
  { name: 'Linda B.',    flag: '🇬🇧', location: 'Birmingham', product: '1 Pair' },
  { name: 'James L.',    flag: '🇬🇧', location: 'Leeds',   product: '2 Pairs' },
  { name: 'Dorothy W.',  flag: '🇬🇧', location: 'Glasgow',  product: '1 Pair' },
  { name: 'Kenneth R.',  flag: '🇬🇧', location: 'Liverpool',     product: '3 Pairs' },
  { name: 'Barbara S.',  flag: '🇬🇧', location: 'Bristol',  product: '2 Pairs' },
  { name: 'George T.',   flag: '🇬🇧', location: 'Sheffield',    product: '1 Pair' },
  { name: 'Helen J.',    flag: '🇬🇧', location: 'Edinburgh',   product: '2 Pairs' },
  { name: 'Charles P.',  flag: '🇬🇧', location: 'Cardiff',    product: '1 Pair' }
];

let toastIndex = 0;
function showRandomToast() {
  if (window.innerWidth <= 768 && stickyAtcEl && stickyAtcEl.classList.contains('visible')) return;
  var _cd = document.getElementById('cartDrawer');
  if (_cd && _cd.classList.contains('open')) return;
  const p = fakePurchases[toastIndex % fakePurchases.length];
  toastIndex++;
  document.getElementById('toastName').textContent    = p.name;
  document.getElementById('toastFlag').textContent    = p.flag;
  document.getElementById('toastLocation').textContent = p.location;
  document.getElementById('toastProduct').textContent = p.product;
  const toast = document.getElementById('purchaseToast');
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 5000);
}
function hideToast() { document.getElementById('purchaseToast').classList.remove('show'); }
setTimeout(() => { showRandomToast(); setInterval(showRandomToast, 12000); }, 4000);

// ─── USE-CASE TABS ────────────────────────────────────────
function switchUseCase(btn) {
  const target = btn.dataset.tab;
  document.querySelectorAll('.use-case-tab').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.use-case-panel').forEach(p => {
    p.classList.toggle('active', p.dataset.panel === target);
  });
}

// ─── AUDIO DEMO ───────────────────────────────────────────
// ─── AUDIO DEMO — Web Audio crossfade: smooth, gap-free, iOS-safe ──────────
// (iOS ignores HTMLAudio.volume, so we crossfade gain nodes like the product page)
var _audioOnWith = false;
var _wa = { ac:null, gWo:null, gWi:null, bufWo:null, bufWi:null, srcWo:null, srcWi:null, ready:false, loading:false, playing:false };

function _waSupported() { return !!(window.AudioContext || window.webkitAudioContext); }

function _waSrc(buf, gain) {
  var s = _wa.ac.createBufferSource();
  s.buffer = buf; s.loop = true; s.connect(gain);
  return s;
}
function _waStopSrcs() {
  try { _wa.srcWo && _wa.srcWo.stop(); } catch (e) {}
  try { _wa.srcWi && _wa.srcWi.stop(); } catch (e) {}
  _wa.srcWo = _wa.srcWi = null;
}
function _waStartAt(off) {
  _waStopSrcs();
  _wa.srcWo = _waSrc(_wa.bufWo, _wa.gWo);
  _wa.srcWi = _waSrc(_wa.bufWi, _wa.gWi);
  var t = _wa.ac.currentTime;
  try { _wa.srcWo.start(t, off); _wa.srcWi.start(t, off); }
  catch (e) { _wa.srcWo.start(t, 0); _wa.srcWi.start(t, 0); }
  _wa.playing = true;
}
function _waCross(toWith) {
  var t = _wa.ac.currentTime, d = 0.05, steps = 8, i, r, tt, a, b;
  for (i = 0; i <= steps; i++) {
    r = i / steps; tt = t + r * d;
    a = Math.cos(r * Math.PI / 2); b = Math.sin(r * Math.PI / 2); // equal-power
    if (toWith) { _wa.gWo.gain.linearRampToValueAtTime(a, tt); _wa.gWi.gain.linearRampToValueAtTime(b, tt); }
    else        { _wa.gWo.gain.linearRampToValueAtTime(b, tt); _wa.gWi.gain.linearRampToValueAtTime(a, tt); }
  }
}
function _waInit(woUrl, wiUrl) {
  if (_wa.ready || _wa.loading) return Promise.resolve();
  _wa.loading = true;
  try { _wa.ac = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { _wa.loading = false; return Promise.reject(e); }
  _wa.gWo = _wa.ac.createGain(); _wa.gWi = _wa.ac.createGain();
  _wa.gWo.gain.value = 1; _wa.gWi.gain.value = 0;
  _wa.gWo.connect(_wa.ac.destination); _wa.gWi.connect(_wa.ac.destination);
  var dec = function (url) {
    return fetch(url, { mode: 'cors', cache: 'force-cache' })
      .then(function (r) { return r.arrayBuffer(); })
      .then(function (ab) { return _wa.ac.decodeAudioData(ab); });
  };
  return Promise.all([dec(woUrl), dec(wiUrl)]).then(function (bufs) {
    _wa.bufWo = bufs[0]; _wa.bufWi = bufs[1]; _wa.ready = true; _wa.loading = false;
  }).catch(function (e) { _wa.loading = false; throw e; });
}
function _waFallbackStart() {
  var aWo = document.getElementById('audioWithoutSrc');
  var aWi = document.getElementById('audioWithSrc');
  try { if (aWi) aWi.pause(); } catch (e) {}
  if (aWo) { try { aWo.currentTime = 0; aWo.play(); } catch (e) {} }
}

function startAudioDemo() {
  var startEl = document.getElementById('audioDemoStart');
  var controlsEl = document.getElementById('audioDemoControls');
  var aWo = document.getElementById('audioWithoutSrc');
  var aWi = document.getElementById('audioWithSrc');
  var sw = document.getElementById('audioSwitch');
  var waveform = document.getElementById('audioWaveform');
  var withLabel = document.getElementById('audioWith');
  var withoutLabel = document.getElementById('audioWithout');

  if (startEl) startEl.hidden = true;
  if (controlsEl) controlsEl.hidden = false;
  _audioOnWith = false;
  if (sw) sw.classList.remove('on');
  if (waveform) waveform.classList.remove('flat');
  if (withLabel) withLabel.classList.remove('audio-toggle__side--active');
  if (withoutLabel) withoutLabel.classList.add('audio-toggle__side--active');

  if (_waSupported() && aWo && aWi) {
    var woUrl = aWo.currentSrc || aWo.src;
    var wiUrl = aWi.currentSrc || aWi.src;
    _waInit(woUrl, wiUrl).then(function () {
      try { _wa.ac.resume(); } catch (e) {}
      _wa.gWo.gain.cancelScheduledValues(_wa.ac.currentTime);
      _wa.gWi.gain.cancelScheduledValues(_wa.ac.currentTime);
      _wa.gWo.gain.value = 1; _wa.gWi.gain.value = 0;
      _waStartAt(0);
    }).catch(function () { _waFallbackStart(); });
  } else {
    _waFallbackStart();
  }
}

function toggleAudioDemo() {
  var sw = document.getElementById('audioSwitch');
  var waveform = document.getElementById('audioWaveform');
  var withLabel = document.getElementById('audioWith');
  var withoutLabel = document.getElementById('audioWithout');
  var aWo = document.getElementById('audioWithoutSrc');
  var aWi = document.getElementById('audioWithSrc');

  _audioOnWith = !_audioOnWith;
  if (sw) sw.classList.toggle('on', _audioOnWith);
  if (waveform) waveform.classList.remove('flat');

  if (_audioOnWith) {
    if (withoutLabel) withoutLabel.classList.remove('audio-toggle__side--active');
    if (withLabel) withLabel.classList.add('audio-toggle__side--active');
  } else {
    if (withLabel) withLabel.classList.remove('audio-toggle__side--active');
    if (withoutLabel) withoutLabel.classList.add('audio-toggle__side--active');
  }

  if (_waSupported() && _wa.ready) {
    try { _wa.ac.resume(); } catch (e) {}
    if (!_wa.playing) _waStartAt(0);
    _waCross(_audioOnWith); // gap-free equal-power crossfade
  } else {
    // fallback (no Web Audio)
    if (_audioOnWith) {
      var p1 = aWo ? aWo.currentTime : 0;
      if (aWo) aWo.pause();
      if (aWi) { try { aWi.currentTime = p1; } catch (e) {} aWi.play().catch(function () {}); }
    } else {
      var p2 = aWi ? aWi.currentTime : 0;
      if (aWi) aWi.pause();
      if (aWo) { try { aWo.currentTime = p2; } catch (e) {} aWo.play().catch(function () {}); }
    }
  }
}

function stopAudioDemo() {
  var startEl = document.getElementById('audioDemoStart');
  var controlsEl = document.getElementById('audioDemoControls');
  var sw = document.getElementById('audioSwitch');
  var waveform = document.getElementById('audioWaveform');
  var withLabel = document.getElementById('audioWith');
  var withoutLabel = document.getElementById('audioWithout');
  var aWo = document.getElementById('audioWithoutSrc');
  var aWi = document.getElementById('audioWithSrc');

  if (_waSupported() && _wa.ac) {
    _waStopSrcs();
    _wa.playing = false;
    try { _wa.ac.suspend && _wa.ac.suspend(); } catch (e) {}
  }
  if (aWo) { try { aWo.pause(); aWo.currentTime = 0; } catch (e) {} }
  if (aWi) { try { aWi.pause(); aWi.currentTime = 0; } catch (e) {} }

  _audioOnWith = false;
  if (sw) sw.classList.remove('on');
  if (waveform) waveform.classList.add('flat');
  if (withLabel) withLabel.classList.remove('audio-toggle__side--active');
  if (withoutLabel) withoutLabel.classList.add('audio-toggle__side--active');
  if (controlsEl) controlsEl.hidden = true;
  if (startEl) startEl.hidden = false;
}

// ─── ANIMATED STATS ───────────────────────────────────────
function animateStats() {
  const targets = {
    'stat-family': 91,
    'stat-tv': 88,
    'stat-repeat': 84,
    'stat-restaurant': 79
  };
  Object.entries(targets).forEach(([id, target]) => {
    const el = document.getElementById(id);
    if (!el) return;
    let current = 0;
    const step = target / 60;
    const interval = setInterval(() => {
      current = Math.min(current + step, target);
      el.textContent = Math.round(current) + '%';
      if (current >= target) clearInterval(interval);
    }, 16);
  });
}

const statsObs = new IntersectionObserver(([e]) => {
  if (e.isIntersecting) { animateStats(); statsObs.disconnect(); }
}, { threshold: 0.3 });
const statsSection = document.getElementById('statsSection');
if (statsSection) statsObs.observe(statsSection);

// ─── INIT ─────────────────────────────────────────────────
updateStickyAtcDisplay();
evaluateStickyAtc();
// Load real Shopify cart on page load
_fetchCart();

// Smart sticky header — hide on scroll down, show on scroll up
(function() {
  var header = document.getElementById('siteHeader');
  if (!header) return;

  // Measure sticky bar height and expose as CSS variable so header sits below it
  function setStickyBarHeight() {
    var bar = document.querySelector('.sticky-bar');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--sticky-bar-h', h + 'px');
  }
  setStickyBarHeight();
  window.addEventListener('resize', setStickyBarHeight, { passive: true });

  var lastY = 0;
  var threshold = 60;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    if (y <= threshold) {
      header.classList.remove('header--hidden');
    } else if (y > lastY) {
      header.classList.add('header--hidden');
    } else {
      header.classList.remove('header--hidden');
    }
    lastY = y;
  }, { passive: true });
})();
